// extracted by mini-css-extract-plugin
export default {"amount":"Compteur_amount__xEruM","description":"Compteur_description__-VEai"};